import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { deleteAiConversation } from "./routes/deleteAiConversation/deleteAiConversation";
import { getAiConversations } from "./routes/getAiConversations/getAiConversations";
import { getAiConversationMessages } from "./routes/getAiConversationMessages/getAiConversationMessages";
import { postAiConversation } from "./routes/postAiConversation/postAiConversation";
import { postAiStream } from "./routes/postAiStream/postAiStream";

export class SpockClient extends AbstractApiClient {
  public readonly postAiConversation = postAiConversation(this.Instance);
  public readonly postAiStream = postAiStream(this.Instance);
  public readonly getAiConversations = getAiConversations(this.Instance);
  public readonly getAiConversationMessages = getAiConversationMessages(
    this.Instance
  );
  public readonly deleteAiConversation = deleteAiConversation(this.Instance);
}
